import ProgramCollectionPage from './ProgramCollectionPage'

export default ProgramCollectionPage
